export default __webpack_public_path__ + "static/media/Video.a96d66a1.webp";